import { maybeAutoRunTour, runTour } from '../utils/tour'

// Wires a page component up to the shared guided-tour system: auto-runs
// once per device (via localStorage, see utils/tour.js) shortly after the
// page mounts, and re-runs on demand when the header's "?" button emits
// `zc-tour:replay` for this page's key.
//
// `stepsSource` is either a plain driver.js steps array, or a function
// `(vm) => steps` for pages whose step text depends on component state.
export default function createPageTourMixin(tourKey, stepsSource) {
  return {
    mounted() {
      this.$root.$on('zc-tour:replay', this.__onTourReplay)
      this.$nextTick(() => {
        setTimeout(() => {
          maybeAutoRunTour(tourKey, this.__resolveTourSteps())
        }, 450)
      })
    },
    beforeDestroy() {
      this.$root.$off('zc-tour:replay', this.__onTourReplay)
    },
    methods: {
      __resolveTourSteps() {
        return typeof stepsSource === 'function' ? stepsSource(this) : stepsSource
      },
      __onTourReplay(key) {
        if (key === tourKey) {
          this.$nextTick(() => runTour(tourKey, this.__resolveTourSteps()))
        }
      }
    }
  }
}
